import { useMemo } from 'react';
import { useCurrentEventGuestQuery } from '../../apps/stays/StaysQueries.graphql.generated';

interface UseGuestDataOptions {
  eventId?: string;
  skip?: boolean;
}

export const useGuestData = ({ eventId, skip = false }: UseGuestDataOptions) => {
  const {
    data: guestEventData,
    loading,
    error,
  } = useCurrentEventGuestQuery({
    batchMode: 'fast',
    variables: {
      eventId: eventId || '',
    },
    skip: !eventId || skip,
  });

  const person = useMemo(() => {
    return guestEventData?.eventById?.activeSession.person || null;
  }, [guestEventData]);

  return {
    person,
    loading,
    error,
  };
};
